import "./Information.css"

const Information = () => {
    return (
        <div className="info__container">
            {/* <div className="info__information-container info__text">
                <div className="video" style={{ backgroundImage: `url(${require("../../assets/Theke.MP4")})` }}> </div>
                <div>
                    <p>Wir haben jetzt wieder 32 Eissorten für Sie in unserem Eiscafé</p>
                </div>
            </div> */}
            <div className="info__information-container info__text" >
                <div className="video" style={{ backgroundImage: `url(${require("../../assets/xmas.mp4")})` }}> </div>
                <p className="info__header">Liebe Gäste,</p>
                <p>Donnerstag haben wir Ruhetag.</p>
                <p>Alles Liebe,</p>
                <p>Familie Vitanza</p>
            </div>
        </div>
    );
}

export default Information;